// Services/Operations/ProductAPI.js - Add influencer API functions
import api from "../api";
import { 
  login_endpoint,
  profile_endpoint,
  bank_endpoint,
  commissions_endpoint,
  dashboard_endpoint
} from "../api_endpoints";

const { login_API } = login_endpoint;


export const influencerLogin = async (data) => {
  try {
    console.log("Influencer Login API Call Started...", data);
    const response = await api.post(login_API, data);
    console.log("Influencer Login API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("INFLUENCER_LOGIN_API_ERROR..........", error);
    throw error;
  }
};

export const getInfluencerProfile = async (token) => {
  try {
    console.log("Fetching influencer profile...");
    const response = await api.get(profile_endpoint.getProfile, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Influencer Profile Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_INFLUENCER_PROFILE_API_ERROR..........", error);
    throw error;
  }
};

export const updateInfluencerProfile = async (data, token) => {
  try {
    console.log("Updating influencer profile...", data);
    const response = await api.put(profile_endpoint.updateProfile, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Influencer Profile Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_INFLUENCER_PROFILE_API_ERROR..........", error);
    throw error;
  }
};

export const changeInfluencerPassword = async (data, token) => {
  try {
    console.log("Changing influencer password...", data);
    const response = await api.patch(profile_endpoint.changePassword, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Change Influencer Password Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CHANGE_INFLUENCER_PASSWORD_API_ERROR..........", error);
    throw error;
  }
};

export const getInfluencerBankDetails = async (token) => {
  try {
    console.log("Fetching influencer bank details...");
    const response = await api.get(bank_endpoint.getBankDetails, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Influencer Bank Details Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_INFLUENCER_BANK_DETAILS_API_ERROR..........", error);
    throw error;
  }
};

export const updateInfluencerBankDetails = async (data, token) => {
  try {
    console.log("Updating influencer bank details...", data);
    const response = await api.put(bank_endpoint.updateBankDetails, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Influencer Bank Details Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_INFLUENCER_BANK_DETAILS_API_ERROR..........", error);
    throw error;
  }
};

export const deleteInfluencerBankDetails = async (token) => {
  try {
    console.log("Deleting influencer bank details...");
    const response = await api.delete(bank_endpoint.deleteBankDetails, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Delete Influencer Bank Details Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("DELETE_INFLUENCER_BANK_DETAILS_API_ERROR..........", error);
    throw error;
  }
};

export const getInfluencerDashboard = async (token) => {
  try {
    console.log("Fetching influencer dashboard...");
    const response = await api.get(dashboard_endpoint.dashboard_API, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Influencer Dashboard Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_INFLUENCER_DASHBOARD_API_ERROR..........", error);
    throw error;
  }
};

export const getInfluencerCommissions = async (params, token) => {
  try {
    console.log("Fetching influencer commissions...", params);
    const response = await api.get(commissions_endpoint.getCommissions, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Influencer Commissions Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_INFLUENCER_COMMISSIONS_API_ERROR..........", error);
    throw error;
  }
};

export const getInfluencerPayments = async (params, token) => {
  try {
    console.log("Fetching influencer payments...", params);
    const response = await api.get(commissions_endpoint.getPayments, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Influencer Payments Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_INFLUENCER_PAYMENTS_API_ERROR..........", error);
    throw error;
  }
};
export const influencerLogout = async (token) => {
  try {
    console.log("Influencer Logout API Call Started...");
    const response = await api.post(login_endpoint.logout_API, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Influencer Logout API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("INFLUENCER_LOGOUT_API_ERROR..........", error);
    throw error;
  }
};